import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

const RedContext = createContext();

// Clave única para el almacenamiento del navegador
const STORAGE_KEY = 'red_form_draft';
const DISMISSED_KEY = 'red_form_draft_dismissed';

export const RedProvider = ({ children }) => {
	
	// Ref para evitar persistir datos recién cargados del servidor
	const skipNextPersist = useRef(false);
	
	// 1. Inicialización Inteligente: 
	// Intentamos cargar lo que hay en LocalStorage, si no, usamos el estado inicial vacío.
	const [formData, setFormData] = useState(() => {
		const savedData = localStorage.getItem(STORAGE_KEY);
		if (savedData) {
			try {
				return JSON.parse(savedData);
			} catch (error) {
				console.error("Error al parsear datos de LocalStorage", error);
				// Si el JSON está corrupto, devolvemos el estado inicial
			}
		}
		return {
			identidad: {},     // Tab I
			legalSocial: {},   // Tab II
			predio: {},        // Tab III
			infra: {},         // Tab IV
			vidaDeportiva: {}, // Tab V
			diagnostico: {}    // Tab VI
		};
	});

	// 2. Efecto de Persistencia:
    // Persiste formData en localStorage, salvo que sea una carga del servidor.
    useEffect(() => {
        if (skipNextPersist.current) {
            skipNextPersist.current = false;
            return;
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(formData));
    }, [formData]);

    // Efecto para escuchar evento de logout y limpiar el estado
    useEffect(() => {
        const handleLogout = () => {
            console.log('🧹 RedContext: Evento logout detectado, limpiando formData');
            setFormData({
                identidad: {},
                legalSocial: {},
                predio: {},
                infra: {},
                vidaDeportiva: {},
                diagnostico: {}
            });
        };
        
        window.addEventListener('red-logout', handleLogout);
        return () => window.removeEventListener('red-logout', handleLogout);
    }, []);

	const updateSection = (section, data, isServerLoad = false) => {
		if (isServerLoad) {
			skipNextPersist.current = true;
		}
		setFormData(prev => ({
			...prev,
			[section]: data
		}));
		// Si es una edición del usuario (no carga inicial del servidor), 
		// limpiar la bandera de descarte para que el banner reaparezca en la próxima recarga
		if (!isServerLoad) {
			localStorage.removeItem(DISMISSED_KEY);
		}
	};

	// 3. Función de Limpieza:
    // Para cuando el usuario termina de enviar el formulario con éxito.
    const clearPersistedData = () => {
        localStorage.removeItem(STORAGE_KEY);
        setFormData({
            identidad: {},
            legalSocial: {},
            predio: {},
            infra: {},
            vidaDeportiva: {},
            diagnostico: {}
        });
    };

	// Función para depuración
	const debugContext = () => {
		console.group('Debug FormContext');
		console.log('Estado completo:', formData);
		console.log('identidad:', formData.identidad);
		console.log('legalSocial:', formData.legalSocial);
		console.log('predio:', formData.predio);
		console.log('infra:', formData.infra);
		console.log('vidaDeportiva:', formData.vidaDeportiva);
		console.log('diagnostico:', formData.diagnostico);
		console.groupEnd();
	  };

	return (
		<RedContext.Provider value={{ formData, debugContext, updateSection, clearPersistedData }}>
			{children}
			{/*<button
				onClick={debugContext}
				style={{
					position: 'fixed',
					bottom: '20px',
					right: '20px',
					zIndex: 9999,
					padding: '10px',
					background: '#f00',
					color: '#fff',
					border: 'none',
					borderRadius: '4px',
					cursor: 'pointer'
				}}
			>
				Debug Context
			</button>*/}
		</RedContext.Provider>
	);
};

export const useRedContext = () => {
	const context = useContext(RedContext);
	if (!context) {
		throw new Error('useRED debe usarse dentro de un REDProvider');
	}
	return context;
};